(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-auto-cards-scroller-script')
    if (!window.autoCardsScroller && $url) {
      window.autoCardsScroller = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.autoCardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-group"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-before-after-image-group-script')
    if (!window.beforeAfterImageGroup && $url) {
      window.beforeAfterImageGroup = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.beforeAfterImageGroup
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-cards-slider-script')
  if (!window.cardsSliderScriptUrl && $url) {
    window.cardsSliderScriptUrl = $url.value

    var $script = document.createElement('script')
    $script.src = window.cardsSliderScriptUrl
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creativity-spot-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-spot-cards-script')
    if (!window.spotCards && $url) {
      window.spotCards = true

      var $script = document.createElement('script')
      $script.src = $url.value
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-featured-blog-script')
  if (!window.featuredBlog && $url) {
    window.featuredBlog = $url.value

    var $script = document.createElement('script')
    $script.src = window.featuredBlog
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-zoom-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-screen-zoom-text-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-highlights"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multicolumn-v2-script')
  if (!window.multicolumnV2 && $url) {
    window.multicolumnV2 = $url.value

    var $script = document.createElement('script')
    $script.src = window.multicolumnV2
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-accordion-script')
  if (!window.imageAccordion && $url && $url.dataset.designMode !== 'yes') {
    window.imageAccordion = $url.value
    var $script = document.createElement('script')
    $script.src = window.imageAccordion
    $script.defer = 'defer'
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-floating-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-and-floating-card')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-spec-stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-image-stairs-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-toggle-script')
    if (!window.imageTextToggle && $url) {
      window.imageTextToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (function () {
    var LEAD_IN = 24;

    function syncTabScroll(root) {
      var scroller = root.querySelector('.blog-tab-nav');
      var activeTab = root.querySelector('.blog-tab-item.btn');
      if (!scroller || !activeTab) return;

      if (scroller.scrollWidth - scroller.clientWidth <= 0) return;

      var tabRect = activeTab.getBoundingClientRect();
      var scrollerRect = scroller.getBoundingClientRect();
      var tabLeftInContent = (tabRect.left - scrollerRect.left) + scroller.scrollLeft;
      var target = tabLeftInContent - LEAD_IN;

      scroller.scrollLeft = target;
    }

    function loadAggregateScript() {
      var $url = document.querySelector('.as-blog-script');
      if (!window.asMainBlog && $url && $url.dataset.designMode !== 'yes') {
        window.asMainBlog = $url.value;
        var $script = document.createElement('script');
        $script.src = window.asMainBlog;
        $script.defer = 'defer';
        document.body.appendChild($script);
      }
    }

    function init() {
      loadAggregateScript();
      document.querySelectorAll('.main-blog').forEach(function (root) {
        syncTabScroll(root);
      });
    }

    if (document.fonts && document.fonts.ready) {
      void document.fonts.ready.then(function () {
        requestAnimationFrame(init);
      });
    } else {
      requestAnimationFrame(init);
    }

    window.addEventListener('resize', function () {
      document.querySelectorAll('.main-blog').forEach(function (root) {
        syncTabScroll(root);
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-grid-v2-script')
  if (!window.mediaGridV2 && $url) {
    window.mediaGridV2 = $url.value
    var $script = document.createElement('script')
    $script.src = window.mediaGridV2
    $script.defer = 'defer'
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-scale"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-scale-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value

      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-image-static-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-image-static-swiper-script')
  if (!window.multiImageStaticSwiper && $url) {
    window.multiImageStaticSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.multiImageStaticSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-image-swiper-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-image-swiper-v2-script')
  if (!window.multiImageSwiperV2 && $url) {
    window.multiImageSwiperV2 = $url.value

    var $script = document.createElement('script')
    $script.src = window.multiImageSwiperV2
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-image-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-image-swiper-script')
  if (!window.multiImageSwiper && $url) {
    window.multiImageSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.multiImageSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-thumbnail-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var SECTION_SELECTOR = '.as-multi-thumbnail-swiper'
  var SCRIPT_SELECTOR = '.as-multi-thumbnail-swiper-script'
  var observer

  function loadScript() {
    if (window.multiThumbnailSwiper) return

    var $url = document.querySelector(SCRIPT_SELECTOR)
    if (!$url) return

    window.multiThumbnailSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.multiThumbnailSwiper
    $script.defer = true
    document.body.appendChild($script)
  }

  function observeSections() {
    var $sections = document.querySelectorAll(SECTION_SELECTOR)
    if (!$sections.length) return

    var $designModeScript = document.querySelector(SCRIPT_SELECTOR + '[data-design-mode="yes"]')
    if ($designModeScript) {
      loadScript()
      return
    }

    if (!('IntersectionObserver' in window)) {
      loadScript()
      return
    }

    observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue
        observer.disconnect()
        loadScript()
        break
      }
    }, {
      rootMargin: '400px 0px'
    })

    $sections.forEach(function($section) {
      observer.observe($section)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections, { once: true })
  } else {
    observeSections()
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-video-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-image-swiper-script')
  if (!window.multiImageSwiper && $url) {
    window.multiImageSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.multiImageSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-icon-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multicolumn-v2-script')
  if (!window.multicolumnV2 && $url) {
    window.multicolumnV2 = $url.value

    var $script = document.createElement('script')
    $script.src = window.multicolumnV2
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multicolumn-v2-script')
  if (!window.multicolumnV2 && $url) {
    window.multicolumnV2 = $url.value

    var $script = document.createElement('script')
    $script.src = window.multicolumnV2
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-item-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-tab-script')
    if (!window.titleWithTab && $url) {
      window.titleWithTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.titleWithTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-scrolling-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-parallax-scrolling-cards-script')
    if (!window.ParallaxScrollingCards && $url) {
      window.ParallaxScrollingCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.ParallaxScrollingCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewer-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-product-viewer-tabs-script')
    if (!window.productViewerTabs && $url) {
      window.productViewerTabs = $url.value
      var $script = document.createElement('script')
      $script.src = window.productViewerTabs
      $script.defer = 'defer'
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewer-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-pv2-script')
    if (!window.productViewerV2 && $url) {
      window.productViewerV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productViewerV2
      $script.defer = 'defer'
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-viewer-script')
    if (!window.productViewer && $url) {
      window.productViewer = $url.value

      var $script = document.createElement('script') 
      $script.src = window.productViewer
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenario-tab-cards-script')
    if (!window.scenarioTabCards && $url && $url.dataset.designMode !== 'yes') {
      window.scenarioTabCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.scenarioTabCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-tab-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenario-tab-cards-script')
    if (!window.scenarioTabCards && $url && $url.dataset.designMode !== 'yes') {
      window.scenarioTabCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.scenarioTabCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scene-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $src = document.querySelector('.scene-gallery-js-src');
    if (!$src || window._sceneGallery) return;
    window._sceneGallery = true;
    var $script = document.createElement('script');
    $script.src = $src.value;
    document.head.appendChild($script);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-unlock-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scroll-unlock-cards-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video-swiper-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-social-video-swiper-v2-script')
  if (!window.socialVideoSwiper && $url) {
    window.socialVideoSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.socialVideoSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tagline-with-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-tagline-with-text-script')
    if (!window._taglineWithText && $url && $url.dataset.designMode !== 'yes') {
      window._taglineWithText = $url.value
      var $script = document.createElement('script')
      $script.src = window._taglineWithText
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-variant-tab-script')
    if (!window.variantTab && $url) {
      window.variantTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.variantTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
